// Import package components
import { createContext, useContext, useRef } from "react";
import { AuthContext } from "./auth.provider";

import AnnouncementsService from "../services/announcements.service";

export const AnnouncementsContext = createContext();
export const AnnouncementsProvider = ({ children }) => {
  const { user, setUser } = useContext(AuthContext);
  const pendingDismissals = useRef(new Map());
  const contextAnnouncements = {
    dismissAnnouncement: async (user_id, announcement_id) => {
      if (!user_id || announcement_id == null) throw new Error("Missing announcement or user");
      const accountId = user?.account_id;
      const signedInUserId = user?.user?.user_id || user?.user_id;
      const key = JSON.stringify([accountId, signedInUserId, String(announcement_id)]);
      if (pendingDismissals.current.has(key)) return pendingDismissals.current.get(key);

      const request = AnnouncementsService.dismissAnnouncement(user_id, announcement_id).then((response) => {
        // Only remove a notice after persistence succeeds; retain other user changes.
        setUser((current) => {
          if (!current || current.account_id !== accountId ||
            (current.user?.user_id || current.user_id) !== signedInUserId) return current;
          return { ...current, announcements: (current.announcements || []).filter((item) => String(item.id) !== String(announcement_id)) };
        });
        return response;
      }).finally(() => {
        pendingDismissals.current.delete(key);
      });
      pendingDismissals.current.set(key, request);
      return request;
    },
  };

  return (
    <AnnouncementsContext.Provider value={contextAnnouncements}>
      {children}
    </AnnouncementsContext.Provider>
  );
};
